import { frontendURL } from '../../../helper/URLHelper';
import n8nGuide from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/guides/n8n'),
      name: 'n8n_guide',
      component: n8nGuide,
      meta: {
        permissions: ['administrator', 'restricted'],
      }
    },
  ],
};
